// extracted by mini-css-extract-plugin
export default {"showChilePlantsButton":"ShowChilePlantsButton_showChilePlantsButton__tTRC-","showChilePlantsButtonActive":"ShowChilePlantsButton_showChilePlantsButtonActive__jVOZI"};